import {API_URL, apiGetV1} from '../api'

export const getAdvertisementDetail = async (id: string) => {
    return await apiGetV1(API_URL, `admin/advertisement/${id}`)
}
